/** Map View: nearby leads, plus Field Team (rep shift + check-ins; managers see routes). */
import React, { useState } from 'react';
import useAuthStore from '../lib/auth-store';
import NearbyLeadsPage from './NearbyLeadsPage';
import { RepPanel } from '../components/field/RepPanel';
import { ManagerPanel } from '../components/field/ManagerPanel';

const MANAGERS = ['super_admin', 'iso', 'iso_admin', 'iso_agent'];

export default function MapViewPage() {
  const role = useAuthStore((s) => s.user?.role);
  const [tab, setTab] = useState('leads');
  return (
    <div className="space-y-4" data-testid="map-view-page">
      <div className="inline-flex rounded-full border bg-card p-1 text-sm">
        {[['leads', 'Nearby leads'], ['field', 'Field team']].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setTab(k)} data-testid={`map-tab-${k}`}
            className={`rounded-full px-4 py-1.5 transition-colors ${tab === k ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground'}`}>{l}</button>))}
      </div>
      {tab === 'leads' ? <NearbyLeadsPage /> : (
        <div className="space-y-4">
          <RepPanel />
          {MANAGERS.includes(role) && <ManagerPanel />}
          <p className="text-xs text-muted-foreground">Location is recorded only during a field shift while ISOCNTRL is open on the device, with your permission. Gaps appear when the app is closed or the phone is locked.</p>
        </div>
      )}
    </div>
  );
}
